import { ReactElement } from 'react';

import { Icons, Tooltip, TooltipProps, Stack } from '@cast/design-system';

type Props = { children: ReactElement; show?: boolean } & Partial<TooltipProps>;

export const WarningTooltip = ({
  children,
  title,
  show = true,
  color = 'secondary',
  ...tooltipProps
}: Props) => {
  if (!show) {
    return <>{children}</>;
  }
  return (
    <Tooltip
      color={color}
      title={
        <Stack
          direction="row"
          gap={4}
          bgcolor="inherit"
          sx={{ '& svg': { minWidth: '1em' } }}
        >
          <Icons.Info fontSize={16} />
          {title}
        </Stack>
      }
      placement="bottom"
      {...tooltipProps}
    >
      {children}
    </Tooltip>
  );
};
